import type { IConfigurationProfile } from './configuration-profile';

export type ConfigurationProfileStatus = 'ATIVO' | 'INATIVO' | 'AGUARDANDO_VALIDACAO';

export interface ConfigurationProfileStatusOption {
  value: ConfigurationProfileStatus | 'all';
  label: string;
}

export const CONFIGURATION_PROFILE_STATUS_OPTIONS: ConfigurationProfileStatusOption[] = [
  { value: 'all', label: 'Todos' },
  { value: 'ATIVO', label: 'Ativo' },
  { value: 'INATIVO', label: 'Inativo' },
  { value: 'AGUARDANDO_VALIDACAO', label: 'Aguardando validação' },
];

export function getConfigurationProfileStatus(
  profile: Pick<IConfigurationProfile, 'status' | 'validation'>,
): ConfigurationProfileStatus {
  if (profile.status) return profile.status;
  if (profile.validation.by_human || profile.validation.by_system) return 'ATIVO';
  return 'AGUARDANDO_VALIDACAO';
}

export function isProfileActive(profile: {
  status?: ConfigurationProfileStatus;
  validation?: { by_human?: boolean; by_system?: boolean };
  by_human?: boolean;
  by_system?: boolean;
}): boolean {
  if (profile.status) return profile.status === 'ATIVO';
  const validation = profile.validation ?? profile;
  return !!validation.by_human || !!validation.by_system;
}

export type ConfigProfileFilterStatus = ConfigurationProfileStatus;

export const CONFIGURATION_PROFILE_FILTER_STATUS_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'ATIVO', label: 'Ativo' },
  { value: 'INATIVO', label: 'Inativo' },
  { value: 'AGUARDANDO_VALIDACAO', label: 'Aguardando validação' },
] as const;
